import { reducer as alerts } from './alerts'

export const reducers = {
  alerts,
}